import { render, staticRenderFns } from "./AdjustmentsBlock.vue?vue&type=template&id=a4a12172"
import script from "./AdjustmentsBlock.vue?vue&type=script&lang=js"
export * from "./AdjustmentsBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports